<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Data Eksport</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/indagexport">Data Eksport</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Data Eksport</h4>
                  <p class="card-title-desc mb-0">Rekapitulasi Data e-SKA Tahunan.</p>
                </div>
                <div>
                  <!-- <button type="button" class="btn btn-success" @click="form.show = true">Tambah Baru</button> -->
                </div>
              </div>

              <hr>

              <data-attribut :data="indagexport">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th class="text-center">No</th>
                        <th>Tahun</th>
                        <th>No SKA</th>
                        <th>Nama Exporter</th>
                        <th>Volume</th>
                        <th>Satuan</th>
                        <th>Tujuan</th>
                        <th class="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in indagexport.data" :key="index">
                        <td scope="row" class="text-center">{{ indagexport.from + index }}</td>
                        <td scope="row" v-text="row.tahun"></td>
                        <td scope="row" v-text="row.no_ska"></td>
                        <td scope="row" v-text="row.nama_exportir"></td>
                        <td scope="row" v-text="row.berat_bersih"></td>
                        <td scope="row" v-text="row.satuan || '-'"></td>
                        <td scope="row" v-text="row.negara_tujuan"></td>
                        <td scope="row" class="text-center">
                          <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> |
                          <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                        </td>
                      </tr>
                      <tr v-if="indagexport.data.length == 0">
                        <td scope="row" colspan="6" class="text-center">
                          <i>Tidak ditemukan data!</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </data-attribut>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah' : 'Tambah') + ' Exportir'"
    backdrop="static" size="xl">
    <template #default>
      <form @submit.prevent="action">

        <div class="d-flex">
          <div class="p-3 pt-0 flex-fill">
            <div class="mb-2 row">
              <label for="nama_perusahaan" class="col-sm-2 col-form-label">Nama Perusahaan</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="nama_perusahaan"
                  v-model="form.data.nama_exportir">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="nama_pemilik" class="col-sm-2 col-form-label">Nama Pemilik</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="nama_pemilik"
                  v-model="form.data.nama_pemilik">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="alamat" class="col-sm-2 col-form-label">Alamat</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="nama_perusahaan"
                  v-model="form.data.alamat_jalan">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="badan_usaha" class="col-sm-2 col-form-label">Badan Usaha</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="badan_usaha"
                  v-model="form.data.jenis_badan_usaha">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="jenis_industri" class="col-sm-2 col-form-label">Jenis Industri</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="jenis_industri"
                  v-model="form.data.jenis_industri">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="jenis_produk" class="col-sm-2 col-form-label">Jenis Produk</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="jenis_produk"
                  v-model="form.data.jenis_produk">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="kbli" class="col-sm-2 col-form-label">KBLI</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="kbli" v-model="form.data.kbli">
              </div>
            </div>
          </div>

          <!-- <div>
    <button type="button" class="btn btn-outline-success">Ubah Perusahaan</button>
  </div> -->
        </div>

        <ul class="nav nav-tabs mb-3">
          <li class="nav-item"><a class="nav-link cp active">Export</a></li>
          <!-- <li class="nav-item"><a class="nav-link cp">Export</a></li> -->
        </ul>

        <div class="row">
          <div class="d-flex">
            <div class="flex-fill mx-3">
              <div class="mb-2 row">
                <label for="data_tahun" class="col-sm-2 col-form-label">TAHUN</label>
                <div class="col-sm-10">
                  <input type="text" :readonly="form.readonly" class="form-control-plaintext" id="data_tahun"
                    v-model="form.data.tahun">
                </div>
              </div>
            </div>
            <div>
              <button type="button" v-if="form.readonly" class="btn btn-outline-success"
                @click="form.readonly = false">Ubah</button>
              <button type="button" v-if="!form.readonly" class="btn btn-primary me-2" @click="action">Simpan</button>
              <button type="button" v-if="!form.readonly" class="btn btn-danger"
                @click="form.readonly = true">Batal</button>
            </div>
          </div>

          <div class="col-md-6">
            <div class="px-4 py-2 shadow-sm border">
              <div class="mb-2 row">
                <label for="uraian_barang" class="col-sm-5 col-form-label">Urai Barang</label>
                <div class="col-sm-7">
                  <textarea :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="uraian_barang" :readonly="form.readonly" rows="2" v-model="form.data.uraian_barang"></textarea>
                </div>
              </div>
              <div class="mb-2 row">
                <label for="no_ska" class="col-sm-5 col-form-label">No SKA</label>
                <div class="col-sm-7">
                  <input type="text" :readonly="form.readonly"
                    :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                    id="no_ska" v-model="form.data.no_ska">
                </div>
              </div>
              <div class="mb-2 row">
                <label for="tgl_ska" class="col-sm-5 col-form-label">Tanggal SKA</label>
                <div class="col-sm-7">
                  <input type="text" :readonly="form.readonly"
                    :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                    id="tgl_ska" v-model="form.data.tgl_ska">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="px-4 py-2 shadow-sm border">
              <div class="mb-2 row">
                <label for="berat_bersih" class="col-sm-5 col-form-label">Berat Bersih</label>
                <div class="col-sm-7 d-flex gap-2">
                  <input type="text" readonly v-if="form.readonly" class="form-control-plaintext" id="berat_bersih"
                    :value="`${form.data.berat_bersih} ${form.data.satuan}`">
                  <input type="text" v-if="!form.readonly" class="form-control" id="berat_bersih"
                    v-model="form.data.berat_bersih">
                  <input type="text" v-if="!form.readonly" class="form-control" id="satuan"
                    v-model="form.data.satuan">
                </div>
              </div>
              <div class="mb-2 row">
                <label for="fob_usd" class="col-sm-5 col-form-label">FOB (USD)</label>
                <div class="col-sm-7">
                  <input type="number" :readonly="form.readonly"
                    :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                    id="fob_usd" v-model="form.data.fob_usd">
                </div>
              </div>
              <div class="mb-2 row">
                <label for="negara_tujuan" class="col-sm-5 col-form-label">Negara Tujuan</label>
                <div class="col-sm-7">
                  <input type="text" :readonly="form.readonly"
                    :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                    id="negara_tujuan" v-model="form.data.negara_tujuan">
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import DataAttribut from '@/components/DataAttribut'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import axios from 'axios'

export default {
  layout: Layout,
  components: { Modal, DataAttribut },
  props: {
    indagexport: Object
  },
  data() {
    return {
      form: {
        show: false,
        id: null,
        readonly: true,
        data: {}
      },
    }
  },
  methods: {
    edit({ id }) {
      this.form.id = id;
      this.form.show = true;
      this.form.readonly = true;
      // console.log(this.form.id)
      axios.get('/admin/indagexport/' + id)
        .then(res => {
          this.form.data = res.data.export; //Object.assign(res.data, this.form.data);
        })
    },
    action() {
      if (this.form.id) {
        this.$inertia.put('/admin/indagexport/' + this.form.id, this.form.data);
      } else {
        this.$inertia.post('/admin/indagexport', this.form.data);
      }
      this.form.show = false;
      this.form.id = null;
      this.form.data = {};
    },
    remove(row) {
      if (confirm('Konfirmasi Proses Penghapusan?'))
        this.$inertia.delete('/admin/indagdirekikm/' + row.id);
    }
  },
}
</script>
